export default __webpack_public_path__ + "static/media/img_baseBunny_grey.0d94c4d3.jpg";